<template>
    <svg width="126px" height="125px" viewBox="0 0 126 125" class="dotsSVG">
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g
                id="Image-/-Search-not-found-Image-/-Spinner"
                transform="translate(-45.692661, -46.000000)"
                fill="#ABB2FF"
            >
                <g id="Purple-dots" transform="translate(46.000000, 46.000000)">
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 117.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(39.000000, 117.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(78.000000, 117.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 117.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(0.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(26.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(39.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(52.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(65.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(78.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(91.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(117.000000, 104.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 91.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(26.000000, 91.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(91.000000, 91.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 91.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(0.000000, 78.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 78.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 78.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(117.000000, 78.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 65.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 65.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 52.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 52.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(0.000000, 39.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 39.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 39.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(117.000000, 39.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 26.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(26.000000, 26.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(91.000000, 26.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 26.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(0.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(26.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(39.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(52.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(65.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(78.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(91.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(117.000000, 13.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(13.000000, 0.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(39.000000, 0.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(78.000000, 0.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                    <g id="Icon/dot-Shape/dot" transform="translate(104.000000, 0.000000)">
                        <circle id="Oval" cx="4" cy="4" r="4"></circle>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'SpinnerSVG',
};
</script>

<style lang="scss" scoped>
.dotsSVG {
    position: absolute;
    top: 46px;
    left: 46px;
}
</style>
